module.exports = __webpack_public_path__ + "static/media/road.7a89d3ee.gif";